var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	7698: {
		fallback: () => (() => (__webpack_require__(3723))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	4394: {
		fallback: () => (() => (__webpack_require__(7189))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	5244: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	6467: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	1588: {
		fallback: () => (() => (__webpack_require__(1726))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	4137: {
		fallback: () => (() => (__webpack_require__(4518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	3411: {
		fallback: () => (__webpack_require__.e(220).then(() => (() => (__webpack_require__(7220))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	1327: {
		fallback: () => (__webpack_require__.e(708).then(() => (() => (__webpack_require__(1708))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	1627: {
		fallback: () => (__webpack_require__.e(64).then(() => (() => (__webpack_require__(64))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	6862: {
		fallback: () => (__webpack_require__.e(532).then(() => (() => (__webpack_require__(9151))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	9743: {
		fallback: () => (__webpack_require__.e(413).then(() => (() => (__webpack_require__(8413))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	5233: {
		fallback: () => (() => (__webpack_require__(9971))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.5.2",
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zustand",

	},
	4014: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(2181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	4685: {
		fallback: () => (__webpack_require__.e(496).then(() => (() => (__webpack_require__(8496))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@tanstack/react-query",

	},
	3820: {
		fallback: () => (() => (__webpack_require__(5575))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	7163: {
		fallback: () => (() => (__webpack_require__(9013))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-breadcrumb-store",

	},
	218: {
		fallback: () => (__webpack_require__.e(192).then(() => (() => (__webpack_require__(1192))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "zod",

	},
	2949: {
		fallback: () => (__webpack_require__.e(246).then(() => (() => (__webpack_require__(5246))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	3867: {
		fallback: () => (() => (__webpack_require__(8790))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-basket-store",

	},
	9775: {
		fallback: () => (() => (__webpack_require__(1882))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-user-store",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [7698,4394,5244,6467,1588,4137,3411,1327,1627,6862,9743,5233,5244,6467,4014,4137,5233,4685,4394,3820,7163,218];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"163": [
		7163
	],
	"527": [
		4394,
		5244,
		6467,
		1588,
		4137,
		3411,
		1327,
		1627,
		6862,
		9743,
		5233
	],
	"557": [
		2949,
		3867,
		9775
	],
	"636": [
		4685,
		4394,
		3820
	],
	"698": [
		7698
	],
	"792": [
		5244,
		6467,
		4014,
		4137,
		5233
	],
	"897": [
		218
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}